<template>
  <BareAppWraper>
    <nav
      id="top-nav"
      class="nav-bar-wrapper bg-nash-purple600 text-nash-wheat50"
    >
      <a href="https://www.thymecare.com" aria-label="Thyme Care">
        <img
          width="100"
          src="/assets/images/Thyme-Logo-Wordmark-OffWhite.png"
          alt="Thyme Care"
        />
      </a>
    </nav>
    <div id="content-wrapper">
      <main class="justify-center flex content-padding">
        <div class="max-w-3xl md:w-3xl">
          <div class="gap-y-6 grid">
            <h1 data-testid="welcome-header" class="font-normal text-2xl">
              We're sorry, Thyme Care Connect is currently undergoing
              maintenance.
              <b>We'll be back soon.</b>
            </h1>
            <p data-testid="support-text" class="text-nash-purple600">
              If you need support, you can reach Thyme Care anytime 24/7 at
              <a
                :href="`tel:${thymePhoneNumberDisplay}`"
                class="text-nash-purple600"
                >{{ thymePhoneNumberDisplay }}</a
              >
            </p>
            <p
              data-testid="support-text-about-legal"
              class="text-nash-purple600"
            >
              <a :href="externalUrlAboutThyme" class="text-nash-purple600"
                >About</a
              >
              |
              <a :href="externalUrlPrivacyPolicy" class="text-nash-purple600"
                >Legal Terms &amp; Privacy</a
              >
            </p>
          </div>
        </div>
      </main>
    </div>
  </BareAppWraper>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import {
  EXTERNAL_URL_ABOUT_THYME,
  EXTERNAL_URL_PRIVACY_POLICY,
  THYME_PHONE_NUMBER_DISPLAY,
} from '@/libs/thymeInfo'
import BareAppWraper from '@/tokens/BareAppWrapper/BareAppWraper.vue'

export default defineComponent({
  components: {
    BareAppWraper,
  },
  setup() {
    return {
      thymePhoneNumberDisplay: THYME_PHONE_NUMBER_DISPLAY,
      externalUrlAboutThyme: EXTERNAL_URL_ABOUT_THYME,
      externalUrlPrivacyPolicy: EXTERNAL_URL_PRIVACY_POLICY,
    }
  },
})
</script>

<style lang="scss" scoped>
#top-nav {
  @apply flex grow-0 shrink-0;
  @apply items-center;
  @apply w-full;
  @apply px-6 py-3;
  @apply z-10;
}

#content-wrapper {
  @apply space-y-6;
  @apply overflow-auto grow;
}

.content-padding {
  @apply px-6 py-9;
}
</style>
